import { render, staticRenderFns } from "./returnExtensionAgent.vue?vue&type=template&id=0d7547d8&"
import script from "./returnExtensionAgent.vue?vue&type=script&lang=js&"
export * from "./returnExtensionAgent.vue?vue&type=script&lang=js&"
import style0 from "./returnExtensionAgent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports